import { Checkbox } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import { useIntl } from 'react-intl'
import { isLooker } from '../../../services/AccountService'
import CustomAccordion from './utils/CustomAccordion'

const HasDuplicates = ({ onChange, data }) => {
  const intl = useIntl()
  const handleOnClick = isLooker() ? undefined : () => onChange(false)

  return (
    <CustomAccordion
      summary={intl.formatMessage({ id: 'Повторное обращение' })}
    >
      <Box
        className={'fx-nowrap aln-center'}
        sx={{ cursor: 'pointer' }}
        onClick={handleOnClick}
      >
        <Checkbox checked={data.hasDuplicates} disabled={isLooker()} />
        <Typography variant={'subtitle1'}>
          {intl.formatMessage({ id: 'Отметить как повторное обращение' })}
        </Typography>
      </Box>
    </CustomAccordion>
  )
}

export default observer(HasDuplicates)
